import {
  GetCustomizeCar_customizeCar_availableFeatureCategories as FeatureCategory,
  GetCustomizeCar_customizeCar_availableFeatures,
  GetCustomizeCar_customizeCar_availableFeatures as Feature,
} from '../graphql/queries/__generated__/GetCustomizeCar';
import availableFeaturesService from './availableFeaturesService';
import ISection from '../model/ISection';
import FeatureCategoryCodes from '../../gqlStock/enum/FeatureCategoryCodes';
import customise from '../constants/customise';

const availableFeatureCategoriesServices = {
  getAccessoriesFeatureCategory: (featureCategories: FeatureCategory[]) => {
    return featureCategories.filter(featureCategory =>
      featureCategory.code.includes(FeatureCategoryCodes.BMW_ACCESSORIES),
    );
  },
  getAvailableSectionsNames: (featureCategories: FeatureCategory[], features: Feature[]): FeatureCategory[] => {
    return featureCategories.filter(featureCategory => {
      if (featureCategory.parentCategoryCode === null) {
        const section = availableFeatureCategoriesServices.getFeatureCategories(
          featureCategory,
          featureCategories,
          features,
        );
        const featuresTotalCount = availableFeaturesService.getFeaturesTotalCount(section?.categories);

        if (section?.featuresList?.features.length || featuresTotalCount) {
          return featureCategory;
        }

        return false;
      }

      return false;
    });
  },

  getFeatureCategories: (
    featureSection: FeatureCategory,
    featureCategories: FeatureCategory[],
    features: Feature[],
  ): ISection => {
    const section: ISection = {
      label: '',
      code: '',
      featuresList: {
        features: [],
      },
      categories: [],
    };
    section.label = featureSection.label;
    section.code = featureSection.code;
    featureCategories.forEach(featureCategory => {
      const processedFeatures = availableFeaturesService.getAvailableFeatures(featureCategory, features);
      if (featureSection.code === featureCategory.parentCategoryCode) {
        section.categories.push(
          availableFeaturesService.getAvailableFeaturesCategories(featureCategory, processedFeatures),
        );
      } else if (featureSection.code === featureCategory.code) {
        section.featuresList = availableFeaturesService.getAvailableFeaturesOptionList(
          featureCategory,
          processedFeatures,
        );
        section.attributes = featureCategory.attributes;
      }
    });

    return section;
  },

  getFeatureSections: (
    featureSections: FeatureCategory[],
    featureCategories: FeatureCategory[],
    features: Feature[],
  ): ISection[] => {
    const allSections: ISection[] = [];
    featureSections.forEach(featureSection => {
      const section = availableFeatureCategoriesServices.getFeatureCategories(
        featureSection,
        featureCategories,
        features,
      );

      allSections.push(section);
    });

    return allSections;
  },

  getCategoriesWithFeatures: (
    sections: ISection[],
    features: GetCustomizeCar_customizeCar_availableFeatures[],
    isInSalesEnablement: boolean,
  ): ISection[] =>
    sections.filter(section => {
      if (!!isInSalesEnablement) {
        return !features.every(feature => feature.attributes.salespersonViewOnly);
      }

      if (section.featuresList.features.length === 0) {
        return !section.categories.every(category => category.name.includes(customise.DEALER));
      }

      return true;
    }),
};

export default availableFeatureCategoriesServices;
